import { useState } from "react";
import { captureElementsAsImages } from "../utils/pdf/domToImages";
import { generatePdf } from "../utils/pdf/exportPdf";

const getLogoSafe = async (selector) => {
    try {
        const src = document.querySelector(selector)?.src;
        if (!src) return null;

        const response = await fetch(src);
        if (!response.ok) return null;

        const blob = await response.blob();

        return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
        });
    } catch {
        return null;
    }
};

export const usePdfExport = () => {
    const [isExporting, setIsExporting] = useState(false);

    const exportPdf = async ({
        elements,
        logoSelector = "div.hdv-logomarca img",
        content,
        pageOrientation,
        styles,
        onBeforeExport,
        onAfterExport
    }) => {
        try {
            setIsExporting(true);

            if (onBeforeExport) await onBeforeExport();

            let images = [];
            let logo = null;

            if (!content) {
                [images, logo] = await Promise.all([
                    elements ? captureElementsAsImages(elements) : [],
                    getLogoSafe(logoSelector)
                ]);
            } else {
                logo = await getLogoSafe(logoSelector);
            }

            generatePdf({
                content,
                images,
                logo,
                pageOrientation,
                styles
            });

        } catch (err) {
            console.error("Erro ao exportar PDF", err);
        } finally {
            if (onAfterExport) onAfterExport();
            setIsExporting(false);
        }
    };

    return {
        exportPdf,
        isExporting
    };
};